export class Services {
    static STORE = 'Store';
    static SNACKBAR = 'Snackbar';
    static PAYMENT_WIZARD = 'wizard';
    static BILLPAY = 'billpay';
}